import { toast } from "react-toastify";

const successHandle = (message) => {
  if (!message) {
    return;
  }

  toast.success(message, { position: 'bottom-right' });
  return message
}

export default successHandle;